/** 
 * @Desc: 习题列表
 */
<template>
  <div class="component-exercise-list">
    <div
      class="item-exercise"
      :class="{
        'item-exercise': true,
        'item-exercise-hover': editPower && componentType === 1,
        'item-exercise-hover1': editPower && componentType === 4,
      }"
      v-for="(item, index) in exerciseList"
      :key="index"
      :ref="item.type === 4 ? 'exerciseType4' : ''"
    >
      <span
        :class="{
          'exercise-type': true,
          'exercise-type1': item.type === 1,
          'exercise-type2': item.type === 2,
          'exercise-type3': item.type === 3,
          'exercise-type4': item.type === 4,
          }"
        >{{item.type | exerciseType }}</span>
      <!-- 操作 -->
      <div class="operate-box" v-if="false && editPower && componentType === 1">
        <span class="operate-span" @click.stop="$emit('handlerEditExercise', item, index)">
          <i class="iconfont iconbianjizhong"></i>编辑
        </span>
        <span class="operate-span" @click.stop="$emit('handlerDelExercise', item, index)">
          <i class="iconfont iconshanchu"></i>删除
        </span>
        <span
          class="operate-span"
          :class="index === 0 ? 'operate-dis' : ''"
          @click.stop="index && _sort(item, index, 'up')"
        >
          <i class="iconfont iconyidong1"></i>上移
        </span>
        <span
          class="operate-span"
          :class="index === exerciseList.length - 1 ? 'operate-dis' : ''"
          @click.stop="(index !== exerciseList.length - 1) && _sort(item, index, 'down')"
        >
          <i class="iconfont iconyidong"></i>下移
        </span>
      </div>
      <span
        v-if="false && exerciseList.length < 30"
        class="add-next"
        @click="$emit('handlerInsert', 'insert', index)"
        >
        <i class="iconfont iconadd"></i>在此题后插入新的条目
      </span>
      <div class="exercise-content">
        <p class="exercise-question" v-if="item.type !== 4">{{index + 1}}、{{item.params.question }}</p>
        <p
          class="exercise-question"
          v-else
        >{{index + 1}}、{{item.params.question + '（' + item.params.min + '至' + item.params.max + '个字）'}}</p>
        <!-- 单选题 -->
        <div class="exercise-type-n exercise-type-1" v-if="item.type === 1">
          <div
            :class="{
              'exercise-answer': true,
              'mark-answers': (componentType <= 2 || componentType === 5) && item1.isCorrect,
              'exercise-margin-r-0': componentType === 4 || componentType === 5 || componentType === 6
            }"
            v-for="(item1, index1) in item.params.options"
            :key="index1"
          >
            <p class="exercise-answer-p">
              {{item.isCorrect1}}
              <el-radio-group
                v-if="componentType === 4 || componentType === 5 || componentType === 6"
                v-model="item1.isCorrect1"
                @change="_exerciseSelect(Object.assign({index, index1, item, item1}))"
              >
                <!-- @change="$emit('handleExerciseSelect', Object.assign({index, index1, item1, options: item.params.options, type: item.type}))" -->

                <el-radio
                  :class="{
                    'el-radio-readonly': componentType === 5 || componentType === 6,
                    'el-radio-error': componentType === 5 && item1.isCorrect1 && item1.isCorrect !== item1.isCorrect1,
                  }"
                  :disabled="componentType === 5 || componentType === 6"
                  :label="true"
                  :key="true"
                ></el-radio>
              </el-radio-group>
              {{index1 | answerIndex}}. {{item1.answer}}
              <i
                v-if="(componentType <= 2 || componentType === 5) && item1.isCorrect"
                class="iconfont iconzhengque"
              ></i>
            </p>
          </div>
        </div>
        <!-- 多选题 -->
        <div class="exercise-type-n exercise-type-2" v-if="item.type === 2">
          <div
            :class="{
              'exercise-answer': true,
              'mark-answers': (componentType <= 2 || componentType === 5) && item1.isCorrect
            }"
            v-for="(item1, index1) in item.params.options"
            :key="index1"
          >
            <p class="exercise-answer-p">
              <el-checkbox
                v-if="componentType === 4 || componentType === 5 || componentType === 6"
                v-model="item1.isCorrect1"
                :class="{
                  'el-checkbox-readonly': componentType === 5 || componentType === 6,
                  'el-checkbox-error': componentType === 5 && item1.isCorrect1 && item1.isCorrect !== item1.isCorrect1,
                }"
                :disabled="componentType === 5 || componentType === 6"
                @change="_exerciseSelect(Object.assign({index, index1, item, item1}))"
              ></el-checkbox>
              {{index1 | answerIndex}}. {{item1.answer}}
              <i
                v-if="(componentType <= 2 || componentType === 5) && item1.isCorrect"
                class="iconfont iconzhengque"
              ></i>
            </p>
          </div>
        </div>
        <!-- 判断题 -->
        <div class="exercise-type-n exercise-type-3" v-if="item.type === 3">
          <div
            :class="{
              'exercise-answer': true,
              'mark-answers': (componentType <= 2 || componentType === 5) && item.params.isCorrect,
              'exercise-margin-r-0': componentType === 4 || componentType === 5 || componentType === 6
            }"
          >
            <p class="exercise-answer-judgement">
              <el-radio
                v-if="componentType === 4 || componentType === 5 || componentType === 6"
                :class="{
                  'el-radio-readonly': componentType === 5 || componentType === 6,
                  'el-radio-error': componentType === 5 && item.params.isCorrect !== item.params.isCorrect1,
                }"
                v-model="item.params.isCorrect1"
                :disabled="componentType === 5 || componentType === 6"
                :label="true"
                @change="_exerciseSelect(Object.assign({index, item, type: item.type}))"
              ></el-radio>对
              <i
                v-if="(componentType <= 2 || componentType === 5) && item.params.isCorrect"
                class="iconfont iconzhengque"
              ></i>
            </p>
          </div>
          <div
            :class="{
              'exercise-answer': true,
              'mark-answers': (componentType <= 2 || componentType === 5) && !item.params.isCorrect,
              'exercise-margin-r-0': componentType === 4 || componentType === 5 || componentType === 6
            }"
          >
            <p class="exercise-answer-judgement">
              <el-radio
                v-if="componentType === 4 || componentType === 5 || componentType === 6"
                :class="{
                  'el-radio-readonly': componentType === 5 || componentType === 6,
                  'el-radio-error': componentType === 5 && item.params.isCorrect !== item.params.isCorrect1,
                }"
                v-model="item.params.isCorrect1"
                :disabled="componentType === 5 || componentType === 6"
                :label="false"
                @change="_exerciseSelect(Object.assign({index, item}))"
              ></el-radio>错
              <i
                v-if="(componentType <= 2 || componentType === 5) && !item.params.isCorrect"
                class="iconfont iconzhengque"
              ></i>
            </p>
          </div>
        </div>
        <!-- 简答题 -->
        <div 
          
          class="exercise-type-n exercise-type-4" 
          v-if="item.type === 4"
          >
          <span v-if="componentType === 4" class="remark-limit">{{item.params.isCorrect1 ? item.params.isCorrect1.length: 0}}/{{item.params.max}}</span>
          <el-input
            v-if="componentType === 3 || componentType === 4 || componentType === 5 || componentType === 6"
            type="textarea"
            v-model="item.params.isCorrect1"
            :readonly="componentType === 3 || componentType === 5 || componentType === 6"
            :maxLength="item.params.max"
            :class="{
              'answer-line-3': item.params.max <= 200,
              'answer-line-4': item.params.max > 200 && item.params.max <= 300,
              'answer-line-5': item.params.max > 300 && item.params.max <= 400,
              'answer-line-6': item.params.max > 400 && item.params.max <= 500,
              'answer-line-7': item.params.max > 500 && item.params.max <= 600,
              'answer-line-8': item.params.max > 600,
              'error-border': item.error
            }"
            @input="componentType !== 3 && _answerInput(Object.assign({index, item}))"
            @blur="componentType !== 3 && _answerBlur(Object.assign({index}, item))"
          ></el-input>
          <div v-else class="exercise-answer"></div>
          <transition name="fade">
            <span v-if="componentType === 4 && item.error" class="answer-error color-red">请至少输入{{item.params.min}}个字</span>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { throttle } from 'utils/util';
export default {
  name: "ExerciseList",
  props: {
    dataList: {
      type: Array,
      default: []
    },
    componentType: {
      type: [Number, String],
      default: 1 // 1--可编辑，展示正确答案， 2--不可编辑，展示正确答案，3--不可编辑，不展示正确答案，4--不可编辑，不展示正确答案，答题模式，5--查看结果，展示正确/错误答案，阅卷模式，6--不可编辑，不展示正确答案，禁用模式
    },
    editPower: {
      // 是否有操作的权限
      type: Boolean,
      default: false
    },
    markAnswers: {
      // 是否标注答案
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      exerciseList: [],
      isCorrect: 1
    };
  },
  watch: {
    dataList: {
      immediate: true,
      handler(val) {
        console.log('exercise type', this.componentType);
        let _exerciseList = [...val];
        if (this.componentType === 4 || this.componentType === 5 || this.componentType === 6) {
          for (let x of _exerciseList) {
            let studentAnswer = x.studentAnswer;
            if (x.type <= 2 && studentAnswer && studentAnswer.answer) {
              let answer = studentAnswer.answer.split(",");
              answer = answer.map(ele => Number(ele));
              for (let i = 0; i < x.params.options.length; i++) {
                if (answer.includes(i)) {
                  x.params.options[i].isCorrect1 = true;
                } else {
                  x.params.options[i].isCorrect1 = false;
                }
              }
            } else if (x.type === 3 && studentAnswer && studentAnswer.answer) {
              x.params.isCorrect1 = studentAnswer.answer === "true" ? true : false;
            } else if (x.type === 4) {
              if(studentAnswer && studentAnswer.answer) {
                x.params.isCorrect1 = studentAnswer.answer;
              }else {
                x.params.isCorrect1 = '';
              }
            }
          }
        }
        this.exerciseList = JSON.parse(JSON.stringify(_exerciseList));

      }
    }
  },
  filters: {
    exerciseType(val) {
      let _val = "";
      switch (val) {
        case 1:
          _val = "单选题";
          break;
        case 2:
          _val = "多选题";
          break;
        case 3:
          _val = "判断题";
          break;
        case 4:
          _val = "简答题";
          break;
      }
      return _val;
    },
    answerIndex(val) {
      let arr = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
      return arr[val];
    }
  },
  methods: {


    /**
     * 答题
     * **/
    _exerciseSelect(params) {
      let { index, item } = params;
      let { type } = item;
      if(type === 1) { // 单选题
        let { index1, item1 } = params;
        let { options } = item.params;
        let _options = [...options];
        for(let i = 0; i < _options.length; i++) {
          if(Number(index1) !== i) {
            delete _options[i].isCorrect1;
          }else {
            if(item.studentAnswer) {
              item.studentAnswer.answer = i.toString();
            }else {
              item.studentAnswer = {
                answer: i.toString()
              }
            }
            
          }
        } 
        item.params.options = _options;
      }else if(type === 2) { // 单选题
        let { options } = item.params;
        let _options = [...options];
        let _anwser = [];
        for(let i = 0; i < _options.length; i++) {
          if(_options[i].isCorrect1) {
            _anwser.push(i);
          }else {
            delete _options[i].isCorrect1;
          }
        } 
        _anwser = _anwser.join(',');
        if(item.studentAnswer) {
          item.studentAnswer.answer = _anwser;
        }else {
          item.studentAnswer = {
            answer: _anwser
          }
        }
        item.params.options = _options;
      }else if(type === 3 || type === 4) { // 3--选择题  4--简单题
        let _anwser = item.params.isCorrect1.toString();
        if(item.studentAnswer) {
          item.studentAnswer.answer = _anwser;
        }else {
          item.studentAnswer = {
            answer: _anwser
          }
        }
      }
      this.exerciseList[index] = item;
      this.exerciseList = JSON.parse(JSON.stringify(this.exerciseList));
      this.$emit('handlerUpdata', this.exerciseList);
      
    },
    _exerciseError() {
      let _num = -1;
      let _num1 = -1;
     
      for(let x of this.exerciseList) {
        if(x.type === 4) {
          _num++;
          if(x.params.isCorrect1.length < x.params.min) {
            x.error = true;
            if(_num1 === -1) {
              _num1 = _num;
            }
          }
        }
      }
      if(_num1 !== -1) {
        this.$nextTick(() => {
          this.$refs.exerciseType4[_num1].scrollIntoView({ behavior: "smooth" });
        });
      } 
      this.exerciseList = [...this.exerciseList];
    },
    /**
     * 编辑
     * **/
    _edit(item, index) {},
    /**
     * 删除
     * **/
    _del(item, index) {
      this.exerciseList.splice(index, 1);
    },
    /**
     * 移动
     * **/
    _sort(item, index, type) {
      let item1 = {};
      if (type === "up") {
        // 上移
        item1 = Object.assign({}, this.exerciseList[index - 1]);
        this.exerciseList[index] = item1;
        this.exerciseList[index - 1] = item;
      } else {
        // 下移
        item1 = Object.assign({}, this.exerciseList[index + 1]);
        this.exerciseList[index] = item1;
        this.exerciseList[index + 1] = item;
      }
      this.exerciseList = [...this.exerciseList];
      this.$emit("handlerUpdata", this.exerciseList);
    },
    _isCorrect() {},
    _answerInput: throttle(function(item) {
      this._exerciseSelect(item);
    }, 500, false),
    /**
     * 简答题失焦
     * **/
    _answerBlur(item) {
      if(item.studentAnswer && item.studentAnswer.length < item.params.min) {
        this.exerciseList[item.index].error = true;
      }else {
        this.exerciseList[item.index].error = false;
      }
      this.exerciseList = [...this.exerciseList];
    }
  }
};
</script>
<style lang="less">
@color-main: #03B2B2;
.component-exercise-list {
  width: 100%;
  height: 100%;

  .item-exercise {
    width: 90%;
    max-width: 1430px;
    border: 1px solid #D7D7D7;
    border-radius: 6px;
    padding: 14px 20px 20px 100px;
    position: relative;
    margin-bottom: 26px;
    overflow: hidden;

    &.item-exercise-hover:hover {
      border-color: @color-main;

      .exercise-type {
        border-color: @color-main;
        border-top-color: transparent;
        color: @color-main;
      }

      .operate-box {
        display: block;
      }

      .add-next {
        display: inline-block;
      }
    }
    &.item-exercise-hover1 {
      box-shadow:0px 0px 10px 2px rgba(225,225,225,0.3);
      &:hover {
        border-color: #03B2B2;
      }
    }

    .exercise-type {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      font-size: 14px;    
      transform: rotate(-41deg) translate(-46px, -62px);
      height: 64px;
      line-height: 90px;
      width: 190px;
      text-align: center;
      transform-origin: center;
      background: #F9F9F9;
      color: #8A8A8A;
      &.exercise-type1 {
        background: #D1EBFF;
        color: #0076FF;
      }
      &.exercise-type2 {
        background: #D8DBFF;
        color: #6573E7;
      }
      &.exercise-type3 {
        background: #FFE5DC;
        color: #FF6E35;
      }
      &.exercise-type4 {
        background: #E2FFF5;
        color: #42B298;
      }
    }

    .operate-box {
      display: none;
      position: absolute;
      top: -0.5px;
      right: 10px;

      .operate-span {
        border-radius: 0px 0px 4px 4px;
        border: 1px solid #D9D9D9;
        border-top-color: transparent;
        display: inline-block;
        width: 60px;
        text-align: center;
        height: 22px;
        line-height: 22px;
        background: #82D0B1;
        cursor: pointer;
        color: #FFFFFF;
        font-size: 12px;

        .iconfont {
          color: #FFFFFF;
          font-size: 12px;
          padding-right: 4px;

          &:before {
          }
        }

        &:not(.operate-dis):hover {
          background: #35A97A;
        }

        &.operate-dis {
          color: #9A9A9A;
          cursor: not-allowed;

          .iconfont {
            color: #9A9A9A;
          }
        }

        &+.operate-span {
          margin-left: 12px;
        }
      }
    }

    .add-next {
      display: none;
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #35A97A;
      cursor: pointer;

      .iconfont {
        color: #35A97A;
        font-size: 14px;
        padding-right: 4px;
      }

      &:hover {
        color: @color-main;

        .iconfont {
          color: @color-main;
        }
      }
    }

    .exercise-content {
      .exercise-question {
        line-height: 32px;
        font-weight: bold;
      }

      .exercise-type-n {
        .exercise-answer {
          // min-height: 40px;

          .exercise-answer-p, .exercise-answer-judgement {
            height: 30px;
            line-height: 30px;
            padding: 0 20px;
            display: inline-block;
            border: 1px solid transparent;
            position: relative;

            .iconzhengque {
              display: inline-block;
              font-size: 12px;
              color: @color-main;
              background: #FFFFFF;
              width: 14px;
              height: 14px;
              line-height: 14px;
              position: absolute;
              top: -5px;
              right: -6px;
              text-align: center;
            }
          }
        }

        .mark-answers {
          .exercise-answer-p, .exercise-answer-judgement {
            height: 30px;
            line-height: 30px;
            border: 1px solid @color-main;
          }
        }

        &.exercise-type-1 {
          .exercise-answer-p {
            height: auto;
            word-break: break-all;
          }
          .exercise-answer:not(:last-of-type) {
            margin-bottom: 10px;
          }
        }

        &.exercise-type-2 {
          .exercise-answer-p {
            height: auto;
            word-break: break-all;
          }
          .el-checkbox {
            padding-right: 10px;
          }
          .exercise-answer:not(:last-of-type) {
            margin-bottom: 10px;
          }
        }

        &.exercise-type-3 {
          .exercise-answer {
            display: inline-block;
            margin-right: 20px;

            .exercise-answer-judgement {
              padding: 0 24px;
              // width: 80px;
            }
          }
        }

        &.exercise-type-4 {
          position: relative;
          margin-top: 10px;
          margin-bottom: 16px;
          
          .el-textarea__inner {
            height: 88px;
            resize: none;
            padding: 8px 6px;
            border: 1px solid #efefef;
          }
          .answer-line-4 {
            .el-textarea__inner {
              height: 128px;
            }
          }
          .answer-line-5 {
            .el-textarea__inner {
              height: 146px;
            }
          }
          .answer-line-6 {
            .el-textarea__inner {
              height: 188px;
            }
          }
          .answer-line-7 {
            .el-textarea__inner {
              height: 208px;
            }
          }
          .answer-line-8 {
            .el-textarea__inner {
              height: 272px;
            }
          }
          .error-border {
            .el-textarea__inner {
              border-color: #F56C6C;
            }
            
          }
          .remark-limit {
            position: absolute;
            right: 20px;
            bottom: 6px;
            line-height: 1;
            color: #bfbfbf;
            z-index: 1;
          }
          .answer-error {
            font-size: 12px;
            position: absolute;
            bottom: -20px;
            left: 6px;
          }
          
          .fade-enter-active, .fade-leave-active {
            transition: opacity .4s;
          }
          .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
          }
        }

        .exercise-margin-r-0 {
          .el-radio {
            margin-right: 10px !important;

            .el-radio__label {
              display: none;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1600px) {
    .item-exercise {
      padding-left: 80px !important;
    }

    .operate-box {
      .exercise-content {
      }
    }
  }
}
</style>